export const columnData = {
  Code: { name: 'Código', widthCol: '10%' },
  Month: { name: 'Mes', widthCol: '10%' },
  Year: { name: 'Año', widthCol: '10%' },
  TotalAmount: { name: 'Monto total', widthCol: '20%' },
  Status: { name: 'Estado', widthCol: '10%' },
  Description: { name: 'Descripción', widthCol: '30%' },
  IsExtraPayment: { name: 'Es aguinaldo', widthCol: '15%' }
}
